import { NgModule } from '@angular/core';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  CSCaptureDirective,
  CSMaskDirective,
} from '@legacy/utils-contentsquare';

import { formStepReducer } from './+state';
import { formStepFeatureKey } from './+state/progressive-form-step';
import { ProgressiveFormStepConfigEffects } from './+state/progressive-form-step-config.effects';
import { ProgressiveFormEffects } from './+state/progressive-form.effects';
import { progressiveFormReducer } from './+state/progressive-form.reducer';
import { progressiveDisclosureKey } from './+state/progressive-form.selectors';

/**
 * @deprecated - please use the `ProgressiveNGRXFormsModule` instead.
 * For information on how to migrate, see `forms/progressive ngrx forms` in the application docs.
 */
@NgModule({
  imports: [
    CommonUiFormsModule,
    EffectsModule.forFeature([
      ProgressiveFormEffects,
      ProgressiveFormStepConfigEffects,
    ]),
    StoreModule.forFeature(progressiveDisclosureKey, progressiveFormReducer),
    StoreModule.forFeature(formStepFeatureKey, formStepReducer),
    CSCaptureDirective,
    CSMaskDirective,
  ],
  declarations: [],
})
export class ProgressiveFormModule {}
